import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { SEO_PAGES, canonicalFor, seoForPath } from './pages'

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.rel = 'canonical'
    document.head.appendChild(el)
  }
  el.href = href
}

/**
 * Updates the existing head tags (never duplicates them) for the current public
 * route. Unlisted routes (login, legal pages, 404) fall back to the homepage
 * title/description with a self-referencing canonical.
 */
export function SeoHead() {
  const { pathname } = useLocation()
  useEffect(() => {
    const page = seoForPath(pathname) ?? SEO_PAGES[0]
    const url = canonicalFor(seoForPath(pathname)?.path ?? pathname)
    document.title = page.title
    setMeta('name', 'description', page.description)
    setCanonical(url)
    setMeta('property', 'og:title', page.title)
    setMeta('property', 'og:description', page.description)
    setMeta('property', 'og:url', url)
    setMeta('name', 'twitter:title', page.title)
    setMeta('name', 'twitter:description', page.description)
  }, [pathname])
  return null
}
